import * as React from 'react';
import { useState } from 'react';
import styled from '@emotion/styled';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { cloneDeep } from 'lodash';
import { InitFilterEntity } from './Filter/Filter.mock';
import SearchApp from './SearchApp';
import PractitionersList from './PractitionersList';
import Filter from './Filter/Filter';
import { SearchItem } from '../../../interfaces/interfaces';
import ProviderOrFacilityRadioButtons from './ProviderOrFacilityRadioButtons';

const StyledContainerMain = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const StyledContainerSearch = styled.div`
  width: 100%;
  padding-top: 2rem;
  display: flex;
  flex-direction: column;
`;

const StyledContainerFilter = styled.div`
  flex: 1 0 auto;
  margin: 0 5px 0 0;
  width: 20%;
  height: 100%;
`;

const Search = () => {
  const [search, setSearch] = React.useState<SearchItem | null>(null);
  // FILTER STATEMENT
  const [filterData, setFilterData] = useState(InitFilterEntity);
  // flag for practitioner or organization request
  const [providerOrFacilityValue, setProviderOrFacilityValue] = React.useState('practitioner');

  React.useEffect(() => {
    setFilterData(cloneDeep(InitFilterEntity));
    setSearch(null);
  }, [providerOrFacilityValue]);

  return (
    <StyledContainerMain>
      <StyledContainerSearch>
        <ProviderOrFacilityRadioButtons value={providerOrFacilityValue} setValue={setProviderOrFacilityValue} />
        <SearchApp onSearch={setSearch} nameOfSearch={providerOrFacilityValue} />
        <PractitionersList value={search} filterData={filterData} nameOfSearch={providerOrFacilityValue} />
      </StyledContainerSearch>
      <StyledContainerFilter>
        <Filter initFilter={filterData} updateFilter={setFilterData} nameOfSearch={providerOrFacilityValue} />
      </StyledContainerFilter>
    </StyledContainerMain>
  );
};

export default withAuthenticationRequired(Search, {
  onRedirecting: () => <div>Redirecting you to the login page...</div>,
});
